<template>
    <div>
       
      <ActivityMeetingDialog v-if="!showSpinner"
        :meetingDialog="meetingDialog"
        :activity="activity"
        :sendingRequest="sendingRequest"
        :dialog="false"
        @save="saveMeetingDetails"
      />
      <ProgressSpinner
        v-else
        style="width:25px; height:25px; width: 100%;" 
        strokeWidth="2" 
        fill="#EEEEEE" 
        animationDuration=".5s"
      />
    </div>
</template>

<script>
import { completionBody } from "@/mbp/activityFollowUp";
import ActivityMeetingDialog from '../universalComponents/activity/ActivityMeetingDialog.vue'
import ActivityService from "@/service/ActivityService"

export default {
  components: {
    ActivityMeetingDialog
  },
  data: () => ({
    activityService: new ActivityService(),
    meetingDialog: false,
    activity: {},
    sendingRequest: false,
    showSpinner: true,
    tempObj: {
                "id": 3,
                "statusCode": "COMP",
                "statusName": "Completed",
                "colourCode": "badge-success",
                "active": true
            }
  }),
  async created() {
    let activityId = this.$route.params.activityid
    if(activityId)
    {
      this.activity = await this.activityService.getActivity(activityId)
      if(this.activity.activityStatus.statusCode === 'COMP' || this.activity.activityStatus.statusCode === 'TASK' || this.activity.activityStatus.statusCode === '5')
      {
        this.$router.push({ path: `/activities/${activityId}/detail` })   
        this.$toast.add({
          severity: "error",
          summary: "Error Message",
          detail: `This Activity's status has been updated to ${this.activity.activityStatus.statusName} and can't be set as completed.`,
          life: 5000,
        })   
      }
    }
    this.showSpinner = false
  },
  methods: {
    saveMeetingDetails(activity) {
      this.sendingRequest = true 

      // G6: one body for every screen - the result, its notes, and the follow-up when one was asked for
      const obj = completionBody(this.tempObj.id, activity)

      this.activityService
        .updateActivityStatus(this.activity.activityId, obj)
        .then(data => {
          this.sendingRequest = false
          this.meetingDialog = false

          this.$toast.add({
            severity: "success",
            summary: "Success",
            detail: "Status updates.",
            life: 5000,
          })
          if(data > 0)
          {
            this.$router.push({
              name: 'activities'
            });
          }
          else 
          {
            throw new Error('Error updating Activity Status')
          }
        })
        .catch(error => {
          this.sendingRequest = false
          this.meetingDialog = false

          let index = -1, a = 'java.lang.RuntimeException: ';
          if (error.response.data) {
            index = error.response.data.indexOf(a)
          }
          if (index < 0) {
            that.$store.dispatch('addErrorMessage', {
              severity: 'error',
              content: 'Some data was not loaded from "v1/updateActivityStatus/{activityId}"'
            })
          } else {
            that.$toast.add({
              severity: "error",
              summary: "Error Message",
              detail: error.response.data.substr(index + a.length, error.response.data.length - 1),
              life: 5000,
            })
          }
        })

    }
  }
}
</script>